import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const CalendarIcon = ({
  title = 'Calendar',
  style = {
    // This icon was initially imported with a fill color
    color: '#505050',
  },
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent viewBox="0 0 20 20" title={title} style={style} {...props}>
    {/* prettier-ignore */}
    <path fillRule="evenodd" clipRule="evenodd" d="M7.38 1.056a1.122 1.122 0 00-2.241.066v.374H2.147c-.62 0-1.122.502-1.122 1.121v15.706c0 .62.503 1.121 1.122 1.121h15.705c.62 0 1.122-.502 1.122-1.121V2.617c0-.62-.502-1.121-1.122-1.121h-2.991v-.374l-.002-.066a1.122 1.122 0 00-2.242.066v.374H7.382v-.374l-.002-.066zm9.35 5.3V3.74h-1.87V4.86a1.122 1.122 0 01-2.24.066l-.003-.066V3.74H7.382V4.86a1.122 1.122 0 01-2.241.066l-.002-.066V3.74h-1.87v2.617h13.462zM3.27 8.6h13.46v8.601H3.27v-8.6zm8.933 6.73v-1.447h-1.95c1.473-.864 1.9-1.481 1.9-2.23 0-1.102-.929-1.892-2.352-1.892-.765 0-1.687.255-2.32.93l.905 1.102c.42-.353.864-.567 1.415-.567.386 0 .666.164.666.427 0 .412-.238.617-2.747 2.386v1.292h4.483z" />
  </CreateIconComponent>
);

export default CalendarIcon;
